import React from "react";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  Fab,
  List,
  ListItem,
  Avatar,
  ListItemAvatar,
  ListItemText,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Folder, Check, Backup, Error, Add } from "@material-ui/icons";
// import Button from "@material-ui/core/Button";

import { useFileUpload } from "../../hooks";

const FileUpload = (props) => {
  const {
    handleClose,
    AudienceID,
    addMessageToList,
    attachType,
    userId,
    roomToken,
  } = props;

  const {
    acceptedFiles,
    currentUploadFile,
    getInputProps,
    getRootProps,
    process,
    description,
    setDescription,
    descriptionInputRef,
    upload,
    uploading,
    close,
    success,
    failed,
  } = useFileUpload(
    AudienceID,
    handleClose,
    roomToken,
    attachType,
    (response) => {
      
      addMessageToList(response.message);
      handleClose();
    }
  );

  const avatarSelector = (name) => {
    const is_success = success.filter((item) => item === name);
    const is_failed = failed.filter((item) => item === name);
    if (is_success.length === 1) {
      return (
        <Fab aria-label="save" color="primary">
          <Check />
        </Fab>
      );
    }
    if (is_failed.length === 1) {
      return (
        <Fab aria-label="save" color="primary">
          <Error />
        </Fab>
      );
    } else if (currentUploadFile === name) {
      return (
        <Fab aria-label="save" color="default">
          <CircularProgress variant="static" value={process} />
        </Fab>
      );
    } else if (!uploading) {
      return <Folder />;
    } else {
      return <CircularProgress />;
    }
  };

  return (
    <Dialog open={true} onClose={close} aria-labelledby="form-dialog-title">
      <DialogTitle id="scroll-dialog-title">ارسال فایل جدید</DialogTitle>
      <DialogContent>
        <div
          style={{
            border: "2px dashed #ccc",
            borderRadius: "10px",
            height: "70%",
            textAlign: "center",
            padding: "15px",
          }}
          {...getRootProps()}
        >
          <input {...getInputProps()} disabled={uploading} multiple />
          <p>بر روی + کلیک کرده و فایل مورد نظر خود را انتخاب و اپلود نمایید</p>
          <p>حداکثر حجم قابل آپلود ۱۰ مگابایت</p>
          <div className="list_attach_fils">
            <div className="item_attach">
              {acceptedFiles.length > 0 ? (
                <List dense={false}>
                  {acceptedFiles.map((item) => (
                    <ListItem className="item_at_file" key={item.name}>
                      <ListItemAvatar>
                        <Avatar>{avatarSelector(item.name)}</Avatar>
                      </ListItemAvatar>
                      <ListItemText primary={item.name} secondary={null} />
                    </ListItem>
                  ))}
                </List>
              ) : (
                <div className="file_attach">
                  <Add />
                </div>
              )}
            </div>
          </div>
        </div>
        <input
          disabled={uploading}
          type="text"
          value={description}
          placeholder="توضیحات خود را تایپ کنید..."
          className="form-control chat_type"
          onChange={(event) => setDescription(event.target.value)}
          style={{ marginTop: "10px" }}
          autoFocus
          ref={descriptionInputRef}
        />
      </DialogContent>

      <DialogActions>
        {/* <Button
          variant="contained"
          onClick={() => upload()}
          disabled={uploading || acceptedFiles.length === 0}
          color="primary"
          className="button_dialog"
        >
          <Backup style={{ marginLeft: "10px" }} />
          آپلود
        </Button>
        <Button onClick={close} color="primary" className="button_dialog">
          لغو
        
        </Button> */}
        <button
          variant="contained"
          onClick={() => upload()}
          disabled={uploading || acceptedFiles.length === 0}
          className="button"
        >
          <Backup style={{ marginLeft: "10px" }} />
          آپلود
        </button>
        <button onClick={close} color="primary" className="button">
          لغو
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default FileUpload;
